'use strict';

import React from 'react';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { OTNavButton } from './tag/OTLink';
import { selectIsHpa } from '../data/hpa/selectors';
import OTIcon from './tag/OTIcon';
import { showNavModal } from '../data/navigation/actions';

class NavigationDropdown extends React.Component {
  render() {
    let {
      intl,
      isHpa,
      message,
      disabled,
      icon,
      link,
      toggleNavigation,
      toggleNavigationDropdown,
      color,
      notifications,
      showNavModal,
    } = this.props;

    const liClassnames = classnames({
      'ot-nav__item': true,
      'ot-nav__item--green': color === 'green',
    });

    const iconColorMobile = disabled ? 'grey' : color ? 'green' : 'darkblue';

    const linkClassNames = classnames({
      'ot-nav__item__link-wrapper': true,
      'is-disabled': disabled,
    });

    const notificationClassNames = classnames(['ot-nav__item__notification']);

    let _message = message;
    if (isHpa && !!intl.messages[`${_message}.hpa`]) {
      _message = `${_message}.hpa`;
    }
    return (
      <li
        className={liClassnames}
        role="menu"
        aria-label={intl.formatMessage({ id: _message })}
        aria-expanded={this.props.dropdownExtended}
      >
        <>
          <OTNavButton
            classNames={linkClassNames}
            onClick={(e) => {
              toggleNavigationDropdown(e);
            }}
          >
            <div className="ot-nav__item__link">
              <div className={'ot-nav__item__icon'}>
                <OTIcon
                  config={{ ...icon, color: iconColorMobile }}
                  className={'inactive-mobile'}
                />
                <OTIcon
                  config={{ ...icon, color: 'lightblue' }}
                  className={'active-mobile'}
                />

                <OTIcon
                  config={{ ...icon, color: 'white' }}
                  className={'inactive-desktop'}
                />
                <OTIcon
                  config={{ ...icon, color: 'darkblue' }}
                  className={'active-desktop'}
                />
              </div>

              <FormattedMessage id={_message} />

              {notifications && notifications.length > 0 && (
                <span className={notificationClassNames}>
                  {notifications.length}
                </span>
              )}
            </div>
          </OTNavButton>

          {this.props.dropdownExtended &&
            this.props.items.map((link, index) => {
              return (
                <button
                  aria-label={intl.formatMessage({ id: link.message })}
                  role="menuitem"
                  key={index}
                  style={
                    index === 0 ? { borderTop: '1px solid lightgray' } : null
                  }
                  className="ot-nav__item__submenu__item"
                  onClick={(e) => {
                    showNavModal(link.modal, link.isExternal);
                  }}
                >
                  <div>
                    <FormattedMessage id={link.message} />
                    <OTIcon
                      config={{
                        type: 'fa',
                        name: 'icon-external-link',
                        color: 'default',
                      }}
                      style={{
                        fontSize: '12px',
                        marginLeft: '2px',
                        marginTop: '2px',
                      }}
                    />
                  </div>
                </button>
              );
            })}
        </>
      </li>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHpa: selectIsHpa(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showNavModal: (item, isExternal) =>
      dispatch(showNavModal(item, isExternal)),
  };
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavigationDropdown))
);
